const SHOPIFY_VARIANT_ID_PATTERN = /^\d+$/

const COLOR_TERMS = [
  "black",
  "blue",
  "brown",
  "burgundy",
  "charcoal",
  "cream",
  "gray",
  "green",
  "grey",
  "ivory",
  "khaki",
  "maroon",
  "navy",
  "olive",
  "orange",
  "pink",
  "purple",
  "red",
  "tan",
  "teal",
  "white",
  "yellow"
] as const

type VariantSource = {
  url?: string
  variantId?: string
}

export function getShopifyVariantId(product: VariantSource): string | undefined {
  if (product.variantId && SHOPIFY_VARIANT_ID_PATTERN.test(product.variantId)) {
    return product.variantId
  }

  if (!product.url) return undefined

  try {
    const variant = new URL(product.url, "https://example.com").searchParams.get("variant")
    return variant && SHOPIFY_VARIANT_ID_PATTERN.test(variant) ? variant : undefined
  } catch {
    return undefined
  }
}

export function getPreferredColor(searchQuery?: string): string | undefined {
  if (!searchQuery) return undefined

  const query = searchQuery.toLowerCase()
  let preferredColor: string | undefined
  let preferredColorIndex = Number.POSITIVE_INFINITY

  for (const color of COLOR_TERMS) {
    const match = new RegExp(`(^|\\W)${color}(\\W|$)`).exec(query)
    if (match && match.index < preferredColorIndex) {
      preferredColor = color
      preferredColorIndex = match.index
    }
  }

  return preferredColor
}
